import React, { useCallback } from 'react';

import { useTranslation } from '../../../../hooks/useTranslation/useTranslation';
import styles from './ModSearchBar.module.css';
import { ModSearchBarProps } from './ModSearchBar.types';

export const ModSearchBar: React.FC<ModSearchBarProps> = ({
  value,
  onChange,
  onClear,
  placeholder,
  ariaLabel,
  className = '',
  disabled = false,
  id,
}) => {
  const { t } = useTranslation();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleClear = useCallback(() => {
    onChange('');
    if (onClear) {
      onClear();
    }
  }, [onChange, onClear]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape' && value) {
      e.preventDefault();
      handleClear();
    }
  };

  return (
    <div role="search" className={`${styles.container} ${className}`.trim()}>
      <input
        id={id}
        type="search"
        role="searchbox"
        className={styles.input}
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder ?? t.mods.searchPlaceholder}
        aria-label={ariaLabel ?? t.mods.searchAriaLabel}
        disabled={disabled}
        autoComplete="off"
        spellCheck="false"
      />

      <span className={styles.searchIcon} aria-hidden="true">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </span>

      {value && !disabled && (
        <button
          type="button"
          className={styles.clearBtn}
          onClick={handleClear}
          aria-label={t.mods.clearSearch}
          title={t.mods.clearSearch}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
};
